import React, { useState } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  Radio,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ContentWrapper from "../../../common/components/contentWrapper";
import "../../pages/dashboard/style/style.css";
import "../../../common/style/main.css";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { MfaOverallSetting } from "../reducer/actions";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";

const MFAMethodSelection = () => {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showBack, setShowBack] = useState(true);
  const handleSelect = (method) => {
    setSelectedMethod(method);
  };


  const handleContinue = () => {
  if (!selectedMethod || loading) return;

  setLoading(true);
  setShowBack(false);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");

  const userid =
    userDetails?.userid ||
    userDetails?.user?.userid ||
    userDetails?.userId;

  const email =
    userDetails?.email ||
    userDetails?.user?.email;

  const phone =
    userDetails?.phone ||
    userDetails?.user?.phone;

  const countryCode =
    userDetails?.countryCode ||
    userDetails?.user?.countryCode;

  if (selectedMethod === "email" && !email) {
    toast.error("Email not found");
    setLoading(false);
    return;
  }

  if (selectedMethod === "phone" && !phone) {
    toast.error("Phone not found");
    setLoading(false);
    return;
  }

  const payload = {
    userid: userid,
    accountid: sessionStorage.getItem("accountId"),
    is_mfa_enabled: true,
    mfa_channel: selectedMethod,   
    is_remindme_later: false,
    userId: userid,
    type: "otp",
    email: selectedMethod === "email" ? email : null,
    phone: selectedMethod === "phone" ? `${countryCode}${phone}` : null
  };

  MfaOverallSetting(payload, (err, res) => {
    if (err || res?.status !== 1) {
      setLoading(false);
      toast.error("MFA setup failed");
      return;
    }

  setLoading(false);

  if (selectedMethod === "email") {
    toast.success("Verification code sent to your email.");
  } else if (selectedMethod === "phone") {
    toast.success("Verification code sent to your phone.");
  }

  history.push("/mfa-otp-verify", { method: selectedMethod });
});
  };

  const handleBack = () => {
    history.push("/mfa");
  };

  const userDetails = sessionStorage.getItem("userDetails")
  ? JSON.parse(sessionStorage.getItem("userDetails"))
  : null;

  const email =
    userDetails?.email ||
    userDetails?.user?.email ||
    "-";

  const countryCode =
    userDetails?.countryCode ||
    userDetails?.user?.countryCode ||
    "-";

  const phone =
    userDetails?.phonenumber ||
    userDetails?.phone ||
    userDetails?.user?.phonenumber ||
    "-";

  const phonenumber = phone
    ? `${countryCode ? `${countryCode}` : ""} ${phone}`.trim()
    : "-";

  const contentView = (
    <div>
      <Container
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "80vh",
        }}
      >
        <Paper className="border-radius"
          style={{
            width: "100%",
            maxWidth: "600px",   
            borderRadius: "10px",
          }}>

          <div style={{ background: "#383838", padding: "10px" }}>
            <Typography
              variant="h5"
              align="center"
              className="text-white"
            >
              Choose Your Verification Method
            </Typography>
          </div>

          <p
            style={{
              textAlign: "center",
              color: "#555",
              padding: "10px 20px",
              fontSize: "14px"
            }}
          >
            Select how you'd like to receive your verification code
          </p>

          {email && email !== "-" && (
          <div
            onClick={() => handleSelect("email")}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "10px 20px",
              padding: "10px",
              borderRadius: "8px",
              border:
                selectedMethod === "email"
                  ? "2px solid #CAAB74"
                  : "1px solid #ddd",
              background:
                selectedMethod === "email"
                  ? "rgba(202,171,116,0.08)"
                  : "#fff",
              cursor: "pointer",
            }}
          >
            <Radio
              checked={selectedMethod === "email"}
              style={{ color: "#383838" }}
            />

            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                background: "rgba(202,171,116,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <EmailIcon style={{ color: "#CAAB74" }} />
            </div>
            <div>
             <b><p style={{ fontSize: "15px", margin: 0 }}>Email Verification</p></b>
                <p style={{ fontSize: "13px", color: "#777", margin: 1 }}>{email}</p>
             </div>
            </div>
          )}

          <div
            onClick={() => {
              if (phone && phone !== "-" && countryCode && countryCode !== "-") {
                handleSelect("phone");
              }
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              margin: "10px 20px",
              padding: "10px",
              borderRadius: "8px",
              border:
                selectedMethod === "phone"
                  ? "2px solid #CAAB74"
                  : "1px solid #ddd",
              background:
                selectedMethod === "phone"
                  ? "rgba(202,171,116,0.08)"
                  : "#fff",
              cursor:
                phone && phone !== "-" && countryCode && countryCode !== "-"
                  ? "pointer"
                  : "not-allowed",
              opacity:
                phone && phone !== "-" && countryCode && countryCode !== "-"
                  ? 1
                  : 0.5,
            }}
          >
            <Radio
              checked={selectedMethod === "phone"}
              disabled={!phone || phone === "-" || !countryCode || countryCode === "-"}
              style={{ color: "#383838" }}
            />

            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                background: "rgba(202,171,116,0.15)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PhoneIcon style={{ color: "#CAAB74" }} />
            </div>

            <div>
              <b>
                <p style={{ fontSize: "15px", margin: 1 }}>
                  Phone Verification
                </p>
              </b>
              <p style={{ fontSize: "13px", color: "#777", margin: 1 }}>
                {phone && phone !== "-" && countryCode && countryCode !== "-" ? (
                  phonenumber
                ) : (
                  <span style={{ fontStyle: "italic", color: "#d32f2f" }}>
                    Phone Number is not available
                  </span>
                )}
              </p>
            </div>
          </div>

          <div style={{ display: "flex", gap: "10px", padding: "20px" }}>
          {showBack && (
            <Button
              variant="outlined"
              fullWidth
              onClick={handleBack}
              style={{
                background: "#fff",
                color: "#000",
                borderColor: "#383838",
              }}
            >
              Back
            </Button>
          )}
            <Button
              fullWidth
              onClick={handleContinue}
              disabled={!selectedMethod || loading}
              style={{
                backgroundColor: "#CAAB74",
                color: "#fff",
              }}
            >
              Continue
              {loading && (
                <CircularProgress size={20} style={{ color: "#fff" }} />
              )}
            </Button>

          </div>

        </Paper>
      </Container>
    </div>
  );

  return <ContentWrapper contentView={contentView} />;
};

export default MFAMethodSelection;